import { NgTemplateOutlet } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  contentChild,
  ElementRef,
  inject,
  input,
  model,
} from "@angular/core";

import { DropdownChevronComponent } from "./chevron/dropdown-chevron.component";
import { DropdownContentDirective } from "./dropdown-content.directive";

@Component({
  selector: "app-dropdown",
  templateUrl: "./dropdown.component.html",
  styleUrls: ["./dropdown.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  exportAs: "appDropdown",
  imports: [NgTemplateOutlet, DropdownChevronComponent],
  host: {
    "(document:click)": "onDocumentClick($event)",
    "(document:keydown.escape)": "close()",
  },
})
export class DropdownComponent {
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  /** Text rendered on the trigger, to the left of the chevron. */
  public readonly triggerLabel = input<string>("");

  /** Two-way open state — consumers can observe it or drive it programmatically. */
  public readonly open = model<boolean>(false);

  protected readonly menu = contentChild(DropdownContentDirective);

  public toggle(): void {
    this.open.update((open) => !open);
  }

  public close(): void {
    this.open.set(false);
  }

  protected onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target as Node)) {
      this.close();
    }
  }
}
